import UserThumbHorizontal from './UserThumbHorizontal'

export default UserThumbHorizontal
